import { Link, useSearchParams } from 'react-router-dom';

const withLocalParam = (path, searchParams) => {
  const local = searchParams.get('local') || searchParams.get('locale') || searchParams.get('country');
  if (!local) return path;
  const next = new URLSearchParams();
  next.set('local', local);
  return `${path}?${next.toString()}`;
};

const linkClass = 'text-sm text-sand-200/70 transition-colors hover:text-sand-50';

const MarketingFooter = () => {
  const [searchParams] = useSearchParams();

  const columns = [
    {
      title: 'Product',
      links: [
        { label: 'About', to: withLocalParam('/about', searchParams) },
        { label: 'Pricing', to: withLocalParam('/pricing', searchParams) },
        { label: 'Sign up', to: withLocalParam('/signup', searchParams) },
      ],
    },
    {
      title: 'Account',
      links: [
        { label: 'Log in', to: withLocalParam('/login', searchParams) },
        { label: 'Support', to: '/support' },
      ],
    },
    {
      title: 'Legal',
      links: [
        { label: 'Privacy', to: '/privacy-policy' },
        { label: 'Terms', to: '/terms-of-service' },
        { label: 'Delete account', to: '/delete-account' },
      ],
    },
  ];

  return (
    <footer className="border-t border-sand-50/10 bg-ink-950">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-6 lg:px-8 lg:py-16">
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-[1.4fr_repeat(3,1fr)] lg:gap-10">
          <div className="max-w-xs">
            <Link
              to={withLocalParam('/', searchParams)}
              className="font-display text-3xl font-light text-sand-50"
            >
              Spirara<span className="text-saffron-500">.</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-sand-200/55">
              Booking, payments and business management for beauty businesses across Africa.
            </p>
            <a
              href="https://www.instagram.com/withspirara"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 text-sm text-sand-200/70 transition-colors hover:text-sand-50"
            >
              <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
              Instagram
            </a>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-saffron-400/90">
                {column.title}
              </p>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className={linkClass}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 border-t border-sand-50/10 pt-6">
          <p className="text-xs text-sand-200/45">
            &copy; {new Date().getFullYear()} Spirara. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default MarketingFooter;
